export { createHttpRequest } from './httpRequest';
export { canUseEventBridge, getEventBridge } from './eventBridge';
export { startBatchWithReplica } from './startBatchWithReplica';
export { createFlushController } from './flushController';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/transport/index.js
// module id = 1159
// module chunks = 0